var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "XS Button Play",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 965",
    d: "M19.928 12.999L9.072 19.385V6.613z"
  })));
}
export default SvgPlayFilled;